const $ = jQuery.noConflict();

class CYEAccordion {
    constructor() {
        this.block = $('.block-cye');
        this.trigger = this.block.find('.block-cye__trigger');
    }

    init() {
        this.trigger.on('click', this.toggleContent);
    }

    toggleContent() {
        const trigger = $(this);
        const content = trigger.closest('.block-cye').find('.block-cye__wrapper');

        if (trigger.hasClass('active')) {
            trigger.removeClass('active').children('span').text(trigger.data('open'));
            content.slideUp(200);
        } else {
            trigger.addClass('active').children('span').text(trigger.data('close'));
            content.slideDown(200);
        }
    }
}

export default new CYEAccordion();
